import { url } from "./MongoConstants";

const getExchangeTeam = async (team_symbol) => {
    try {
        const server = url;
        const response = await fetch(server + '/api/data/exchange/symbol/' + team_symbol, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return data.data; // Return only the data object, not the whole response
        } else {
            console.log('Failed to get team');
            return null;
        }
    } catch (error) {
        console.error('An error occurred:', error);
        return null;
    }
};

export default getExchangeTeam;